var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.227 12.76H5.94l.667-1.358 11.085-.02a.775.775 0 0 0 .763-.638L19.99 2.15a.775.775 0 0 0-.76-.913L5.128 1.192l-.12-.567A.793.793 0 0 0 4.234 0H.788a.788.788 0 1 0 0 1.575h2.809l.526 2.504 1.297 6.276-1.67 2.725a.78.78 0 0 0-.066.821.785.785 0 0 0 .703.433h1.401A2.291 2.291 0 0 0 7.618 18a2.291 2.291 0 0 0 1.83-3.666h3.594A2.291 2.291 0 0 0 14.872 18a2.291 2.291 0 0 0 1.83-3.666h2.527a.789.789 0 0 0 .788-.788.79.79 0 0 0-.79-.785ZM5.456 2.746l12.848.042-1.259 7.046-10.092.018-1.497-7.106Zm2.162 13.67a.707.707 0 0 1-.705-.704c0-.389.316-.705.705-.705a.707.707 0 0 1 .498 1.203.705.705 0 0 1-.498.207Zm7.254 0a.707.707 0 0 1-.705-.704c0-.389.316-.705.705-.705a.707.707 0 0 1 .498 1.203.705.705 0 0 1-.498.207Z",
    fill: "#F0EAE3"
  })));
};

export default SvgCart;